class SiteHeader extends HTMLElement {
  constructor () {
    super()
  }

  connectedCallback () {
    this.isTransparent = this.hasAttribute('data-transparent')

    this.header = document.querySelector('.section-header')
    this.headerScrollThreshold = Number(this.getAttribute('data-scroll-threshold'))
    this.onScrollHandler = this.onScroll.bind(this)

    this.setHeaderHeight()
    this.addListeners()

  }

  addListeners () {
    window.addEventListener('scroll', this.onScrollHandler, false)
    window.matchMedia('(max-width: 990px)').addEventListener('change', this.setHeaderHeight.bind(this))
  }

  setHeaderHeight () {
    const stickyHeader = document.querySelector('[js-header]') || this.header

    document.documentElement.style.setProperty('--header-height', `${stickyHeader.offsetHeight}px`)
  }

  disconnectedCallback () {
    window.removeEventListener('scroll', this.onScrollHandler)
  }

  onScroll () {
    const scrollTop = window.pageYOffset || document.documentElement.scrollTop

    if (this.isTransparent) {
      if (scrollTop > this.headerScrollThreshold) {
        document.documentElement.classList.remove('transparent-header')
      } else {
        document.documentElement.classList.add('transparent-header')
      }
    }
  }
}

customElements.define('site-header', SiteHeader)
